export const calculateWeeklyDiscount = (nights, price) => {
  if (nights >= 30) {
    return price * 0.2; // 20% monthly discount
  } else if (nights >= 7) {
    return price * 0.1; // 10% weekly discount
  }
  return 0;
};
